"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Analytics = exports.AnalyticsServicesEnum = void 0;
// @ts-ignore
var react_intercom_1 = require("react-intercom");
// @ts-ignore
var md5_1 = __importDefault(require("crypto-js/md5"));
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
exports.AnalyticsServicesEnum = Object.freeze({
    all: 3,
    googleAnalytics: 0,
    intercom: 1,
    mixpanel: 2
});
var ENV;
window.USER_INFO = {};
exports.Analytics = {
    init: function (env) {
        if (!(env === null || env === void 0 ? void 0 : env.ANALYTICS_ACTIVE)) {
            return;
        }
        react_gtm_module_1["default"].initialize({ gtmId: env.GOOGLE_TAG_MANAGER_APP_ID });
        mixpanel_browser_1["default"].init(env.MIXPANEL_APP_ID, {
            debug: env.MIXPANEL_DEBUG,
            persistence: "localStorage"
        });
        ENV = env;
    },
    track: function (eventCategory, eventAction, options) {
        var _a;
        if (options === void 0) { options = {
            services: [exports.AnalyticsServicesEnum.all],
            extraParams: {},
            joinCategory: true,
            disableIntercomCategory: false
        }; }
        if (!ENV) {
            console.log("%c Analytics event ".concat(eventCategory, ".").concat(eventAction, " triggered"), "color: cyan;font-size:1rem;", { event: "".concat(eventCategory, ".").concat(eventAction), data: options });
            return;
        }
        var userParams = {};
        var joinCategory = typeof options.joinCategory === "undefined" ? true : options.joinCategory;
        var params = options.extraParams ? options.extraParams : {};
        var servicesToUse = options.services
            ? options.services
            : [exports.AnalyticsServicesEnum.all];
        var eventName = joinCategory
            ? "".concat(eventCategory, ".").concat(eventAction)
            : eventAction;
        userParams.isMasquerade = window.USER_INFO.masquerade;
        params.isMasquerade = window.USER_INFO.masquerade;
        var deviceInfo = {
            screen: "".concat(window === null || window === void 0 ? void 0 : window.innerWidth, "x").concat(window === null || window === void 0 ? void 0 : window.innerHeight),
            device: (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent
        };
        if (window.USER_INFO.distinctId) {
            userParams.userId = window.USER_INFO.distinctId;
        }
        servicesToUse.forEach(function (service) {
            switch (service) {
                case exports.AnalyticsServicesEnum.googleAnalytics:
                    react_gtm_module_1["default"].dataLayer({
                        dataLayer: __assign(__assign({ event: "gaEvent", gaEventCategory: eventCategory, gaEventAction: eventAction }, deviceInfo), userParams)
                    });
                    break;
                case exports.AnalyticsServicesEnum.intercom:
                    (0, react_intercom_1.IntercomAPI)("trackEvent", options.disableIntercomCategory ? eventAction : eventName);
                    break;
                case exports.AnalyticsServicesEnum.mixpanel:
                    mixpanel_browser_1["default"].track(eventName, __assign(__assign({}, deviceInfo), { params: params }));
                    break;
                default:
                    react_gtm_module_1["default"].dataLayer({
                        dataLayer: __assign({ event: "gaEvent", gaEventCategory: eventCategory, gaEventAction: eventAction }, userParams)
                    });
                    (0, react_intercom_1.IntercomAPI)("trackEvent", eventName);
                    mixpanel_browser_1["default"].track(eventName, params);
                    break;
            }
        });
    },
    setUserInfo: function (user) {
        var _a, _b, _c;
        if (!ENV.ANALYTICS_ACTIVE) {
            return;
        }
        var userInfo = {
            distinctId: (0, md5_1["default"])(user.email).toString(),
            name: user.name,
            email: user.email,
            created_at: user.created,
            userType: user.userType,
            company: user.company.name,
            introducerType: user.introducerType,
            consultant: user.consultant,
            masquerade: user.masquerade,
            membership: (_b = (_a = user === null || user === void 0 ? void 0 : user.membership) === null || _a === void 0 ? void 0 : _a.level) === null || _b === void 0 ? void 0 : _b.name,
            companyType: (_c = user === null || user === void 0 ? void 0 : user.company) === null || _c === void 0 ? void 0 : _c.type
        };
        if (window.USER_INFO.distinctId &&
            window.USER_INFO.distinctId === userInfo.distinctId) {
            return;
        }
        window.USER_INFO = userInfo;
        mixpanel_browser_1["default"].identify(window.USER_INFO.distinctId);
        mixpanel_browser_1["default"].people.set_once(userInfo);
    },
    setUserExtraInfo: function (extraProps) {
        if (!window.USER_INFO.distinctId) {
            return;
        }
        mixpanel_browser_1["default"].people.set_once(extraProps);
    },
    appendUserInfo: function (_a) {
        var membership = _a.membership;
        if (!window.USER_INFO.distinctId) {
            return;
        }
        mixpanel_browser_1["default"].identify(window.USER_INFO.distinctId);
        mixpanel_browser_1["default"].people.set({ membership: membership });
    }
};
